import React from 'react';
import { IMaskInput } from 'react-imask';

const InputMaskComponent = React.forwardRef(({ mask, ...props }, ref) => {
  let normalizedMask = mask;

  if (typeof mask === 'string') {
    normalizedMask = mask.replace(/9/g, '0');
  }

  return (
    <IMaskInput
      mask={normalizedMask}
      inputRef={ref}
      {...props}
    />
  );
});

InputMaskComponent.displayName = 'InputMask';

export default InputMaskComponent;